export default "__VITE_ASSET__DO_9CvPq__"